---
label: Editing
category: sequences
icon: TextCursorIcon
keywords: [edit, insert, delete, select, copy, paste, undo, redo]
addedInVersion: "0.0.0"
---

# Editing

Click on a sequence to place the cursor, then type to insert nucleotides or
amino acids. Only valid characters for the sequence type are accepted.

Sequences larger than 500 KB are read-only. Locked sequences cannot be edited
until unlocked.

## Selecting

Click and drag on the sequence to select a range. Hold <Kbd>Shift</Kbd> and
click or use <Kbd>Shift</Kbd> with any movement key to extend the selection.
Use <KbdGroup><Mod /> + <Kbd>A</Kbd></KbdGroup> to select all.

Selections are used for creating features, copying, cutting, deleting, and
starting BLAST searches.

## Deleting

<Kbd>Backspace</Kbd> deletes the character before the cursor.
<Kbd>Delete</Kbd> deletes the character after it. With a selection active,
either key deletes the entire selected range.

## Clipboard

| Action | Shortcut |
|---|---|
| Copy | <KbdGroup><Mod /> + <Kbd>C</Kbd></KbdGroup> |
| Cut | <KbdGroup><Mod /> + <Kbd>X</Kbd></KbdGroup> |
| Paste | <KbdGroup><Mod /> + <Kbd>V</Kbd></KbdGroup> |
| Paste reverse complement | <KbdGroup><Mod /> + <Kbd>Shift</Kbd> + <Kbd>V</Kbd></KbdGroup> |

Paste reverse complement is available for nucleotide sequences only.

## Undo and Redo

| Action | Shortcut |
|---|---|
| Undo | <KbdGroup><Mod /> + <Kbd>Z</Kbd></KbdGroup> |
| Redo | <KbdGroup><Mod /> + <Kbd>Y</Kbd></KbdGroup> or <KbdGroup><Mod /> + <Kbd>Shift</Kbd> + <Kbd>Z</Kbd></KbdGroup> |

## Navigation

| Action | Shortcut |
|---|---|
| Move cursor | <Kbd>←</Kbd> <Kbd>→</Kbd> <Kbd>↑</Kbd> <Kbd>↓</Kbd> |
| Jump by chunk | <KbdGroup><Mod /> + <Kbd>←</Kbd></KbdGroup> / <KbdGroup><Mod /> + <Kbd>→</Kbd></KbdGroup> |
| Jump to start / end | <Kbd>Home</Kbd> / <Kbd>End</Kbd> |
